export enum QuestionSizeTypes {
    DECISION_TREE = 'decision_tree',
    DYNAMIC = 'dynamic',
    FIXED = 'fixed',
    PREVIOUS_QUESTION = 'previous_question',
}